
import React, { useEffect, useState, useRef } from 'react';
import  Box from '@mui/material/Box';
import useMediaQuery from '@mui/material/useMediaQuery';
import { Sidebar } from '../components/sidebar';
import { ChartDisplayThree } from '../components/chartDisplayThree';
import './SeanPage.css';
import { useRockbashAccuracy, useUserRole } from '../api/GetData';
import DialChart from "../components/DialChart";

const ForecastPage = ({ visibleSections, pageKey = "CustomerPersona", plantName }) => {
    const isDesktop = useMediaQuery("(min-width:720.9px)")
    const defaultCharts = {
        short_forecast: true,
        pool_price: true,
        accuracy_histogram: true,
        generation: true,
        sevenD_accuracy: true,
        quantify_beta: true,
        revenue: true,
        ST_supply: true,
        LT_rockbash: true,
        LT_supply: true,
        total_generation: true,
        gross_profit: true,
        accuracy_dials: true,
        }
    const {data: userProfile} = useUserRole()
    const role = (userProfile || '').toLowerCase()
    const [selectedCharts, setSelectedCharts] = useState(defaultCharts);
      useEffect(() => {
    const saved = localStorage.getItem(pageKey);
    if (saved) setSelectedCharts(JSON.parse(saved));}, []);

    // Original values
    const [accuracy, setAccuracy] = useState(0)
    const [bidAccuracy, setBidAccuracy] = useState(0)
    // Placeholder 24-hour values (for now same as above)
    const [accuracy24h, setAccuracy24h] = useState(0)
    const [bidAccuracy24h, setBidAccuracy24h] = useState(0)
    const { isPending, isError, data, error } = useRockbashAccuracy()
    useEffect(()=>{
        if(Array.isArray(data) && data.length>0){
            const latest = data[0] || {}
            setAccuracy(Number(latest.avg_accuracy||0))
            setBidAccuracy(Number(latest.bid_accuracy_true||0))
            setBidAccuracy24h(Number(latest.bid_accuracy_true_24h||0))
            setAccuracy24h(Number(latest.avg_accuracy_24h||0))
        } else {
            setAccuracy(0)
            setBidAccuracy(0)
            setBidAccuracy24h(0)
            setAccuracy24h(0)
        }
    }, [data])

     return (
    <div style={{
            width: '100vw',
              height: "100dvh",
              overflowY: "auto", // scroll charts independently
            "&::-webkit-scrollbar": { display: "none" },
            scrollbarWidth: "none",
            paddingBottom: "calc(var(--safe-area-bottom, 0px) + 80px)",
            boxSizing: "border-box",
            }}
    >
      <>
          {/* Top bar showing accuracy metrics */}
          {selectedCharts.accuracy_dials && role=="dev" &&  (
              <div
            style={{
              display: "flex",
              justifyContent: "space-around",
              alignItems: "center",
              backgroundColor: "#0b1422",
              padding: "5px",
              borderRadius: "8px",
              marginBottom: "10px",
              flexWrap: "wrap",
            }}
          >
            <DialChart
              title="Accuracy" value={Number(accuracy)} size={100} arrow="up" maxValue={400}
            />
            <DialChart
            title="Bid Accuracy" value={Number(bidAccuracy)}size={100}arrow="up"maxValue={100}
            />
            <DialChart
              title="24h Accuracy" value={Number(accuracy24h)} size={100}arrow="up"maxValue={400}
            />
            <DialChart
              title="24h Bid Accuracy" value={Number(bidAccuracy24h)} size={100} arrow="up"  maxValue={100}
            />
          </div>
          )}
        

          {/* Main content area */}
          {isDesktop ? (
            <Box sx={{ gap: 2,display: "flex" , flexDirection: "row-reverse"}}>
              {/* Charts Grid */}
              <Box
                sx={{
                  display: "grid",
                  gridTemplateColumns: "repeat(auto-fill, 1fr)",
                  gap: 1,
                  overflowY: "auto", // scroll charts independently
                  "&::-webkit-scrollbar": { display: "none" },
                  scrollbarWidth: "none",
                  width: "calc(100vw - 150px)",
                  backgroundColor: "#0b1422",
                  height: "100vh",
                }}
              >
                <ChartDisplayThree selectedCharts={selectedCharts} plantName={plantName} />
              </Box>
                {/* SIDEBAR */} 
              <Box
                sx={{
                  width: '15vw', // fixed sidebar width
                  flexShrink: 0,
                  height: "calc(100dvh - 80px - var(--safe-area-bottom, 0px))",
                  position: "sticky",
                  top: 0,
                }}
              >
                <Sidebar visibleSections={visibleSections} plantName={plantName} />
              </Box>
            </Box>
          ) : (
            <Box
              sx={{
                display: "flex",
                "&::-webkit-scrollbar": { display: "none" },
                scrollbarWidth: "none",
                width: "100%",
                backgroundColor: "#0b1422",
                paddingBottom: "var(--safe-area-bottom, 0px)",
                boxSizing: "border-box",
                flexWrap: 'wrap',
              }}
            >
              <Sidebar set={[true,true,true,true,false,true,true]} plantName={plantName} />
              <ChartDisplayThree selectedCharts={selectedCharts} style={{ flex: 1 }} plantName={plantName}  />
            </Box>
          )}
        </>
    </div>
  );
};

export default ForecastPage;
